<template>
  <div id="rewards" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_rewards.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.rewards") }}</span>
        <div class="page-des page-des-line-button">
          {{ $t("page.rewards_description") }}
        </div>
        <div class="button-title">
          <el-badge :value="badgeRedeemed" class="happily-primary">
            <el-button
              class="buttonRedeemed btn-gray-outline"
              style="color: #939393"
              @click="openRedeemed"
            >
              <div class="flex-mid">
                <img
                  :src="$utils('icons', 'bar_chart_gray_24dp')"
                  alt="icons_bar_chart_gray_24dp"
                  class="mb-3 mr-6"
                />
                {{ $t("rewards.Activity") }}
              </div>
            </el-button>
          </el-badge>
          <el-button
            class="buttonTitle"
            type="primary"
            @click="dialogFormReward = true"
            >{{ $t("rewards.add_a_reward") }}</el-button
          >
        </div>
      </div>
      <el-tabs class="style-bar" v-model="tab" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in tagMaster" :key="index" :name="index.toString()">
          <template #label>
          <span class="title-bar">
            {{ $t(`page.${item.value}`) }} 
            {{countNewReward[item.value]?`(${countNewReward[item.value]})`:''}}
          </span>
        </template>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>
              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown"
                        >{{ selectStatus }} ({{
                          countrewards[status]
                            ? $utils("addCommasInNumber", countrewards[status])
                            : 0
                        }})</span
                      >
                    </template>
                    <el-menu-item
                      @click="statusClick('Active')"
                      index="1"
                      style="font-size: 16px; width: 320px"
                      >{{ "Enabled" }} ({{
                        countrewards.Y ? countrewards.Y : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Inactive')"
                      index="2"
                      style="font-size: 16px; width: 320px"
                      >{{ "Disabled" }} ({{
                        countrewards.N ? countrewards.N : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Show All')"
                      index="3"
                      style="font-size: 16px; width: 320px"
                      >{{ "Show All Status" }} ({{
                        countrewards.all ? countrewards.all : 0
                      }})</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table2"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="
                        scope.row.disabled && scope.row.disabled === 'Y'
                          ? true
                          : false
                      "
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                      />
                      <div v-else class="divTitle" />
                      <div v-if="!scope.row.oldreward?true:false" style="position: absolute; top: 25px;width: 44px;height: 19px; right: 0;font-size: 12px;background-color: #35D077; color: #fff; text-align: center;border-radius: 3px;display: flex;justify-content: center;"><span style="text-align: center;width: 100%;">NEW</span></div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="430"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-16 fc-4A4A4A">
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-14"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.coins')"
                  prop="coins"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 16px; color: #4a4a4a; font-weight: 500">{{
                      $utils("addCommasInNumber", scope.row.coins)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.gems')"
                  prop="gems"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 16px; color: #4a4a4a; font-weight: 500">{{
                      $utils("addCommasInNumber", scope.row.gems)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="editRewardNew(scope.$index, scope.row)"
                      class="buttonEdit btn-gray-outline"
                      type
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane name="0">
          <span slot="label" class="title-bar">{{
            $t("page.gift_cards")
          }}</span>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>
              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown"
                        >{{ selectStatus }} ({{
                          countrewards[status]
                            ? $utils("addCommasInNumber", countrewards[status])
                            : 0
                        }})</span
                      >
                    </template>
                    <el-menu-item
                      @click="statusClick('active')"
                      index="1"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.add_a_reward") }} ({{
                        countrewards.Y ? countrewards.Y : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Inactive')"
                      index="2"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.inactive") }} ({{
                        countrewards.N ? countrewards.N : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Show All')"
                      index="3"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.show_all") }} ({{
                        countrewards.all ? countrewards.all : 0
                      }})</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table2"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="
                        scope.row.disabled && scope.row.disabled === 'Y'
                          ? true
                          : false
                      "
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                      />
                      <div v-else class="divTitle" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="430"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-18 fc-4A4A4A">
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-16"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.coins')"
                  prop="coins"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      $utils("addCommasInNumber", scope.row.coins)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.gems')"
                  prop="gems"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      $utils("addCommasInNumber", scope.row.gems)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="editRewardNew(scope.$index, scope.row)"
                      class="buttonEdit btn-gray-outline"
                      type
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label" class="title-bar">{{
            $t("page.perks")
          }}</span>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>

              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown"
                        >{{ selectStatus }} ({{
                          countrewards[status]
                            ? $utils("addCommasInNumber", countrewards[status])
                            : 0
                        }})</span
                      >
                    </template>
                    <el-menu-item
                      @click="statusClick('Active')"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.active") }} ({{
                        countrewards.Y ? countrewards.Y : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Inactive')"
                      index="2"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.inactive") }} ({{
                        countrewards.N ? countrewards.N : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Show All')"
                      index="3"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.show_all") }} ({{
                        countrewards.all ? countrewards.all : 0
                      }})</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                      />
                      <div v-else class="divTitle" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="450"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-18 fc-4A4A4A">
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-16"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="coins"
                  :label="$t('rewards.coins')"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      scope.row.coins
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="gems"
                  :label="$t('rewards.gems')"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      scope.row.gems
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      class="buttonEdit btn-gray-outline"
                      type
                      @click="editRewardNew(scope.$index, scope.row)"
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <div id="reward_form_modal">
      <el-dialog
        :visible.sync="dialogFormReward"
        width="1008px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="cancelReward"
      >
        <div class="grid-2-section">
          <div class="grid-left">
            <div class="header flex-center">
              <img
                :src="$utils('icons', 'ic_preview')"
                style="height: 24px; margin-top: -2px"
                class="mr-12"
              />
              <span>{{ $t("rewards.preview_on_mobile") }}</span>
            </div>
            <div class="body">
              <div class="image-container">
                <div class="image-box flex-mid" style="position: relative">
                  <img
                    v-if="imageUrl"
                    v-lazy="imageUrl"
                    class="avatar image-skeleton"
                  />
                  <div
                    v-else
                    class="flex-mid"
                    style="width: 192px; height: 192px"
                  >
                    <img
                      src="../assets/images/uploadimg@2x.png"
                      class="avatar-uploader-icon"
                    />
                  </div>
                  <div
                    class="absolute-mid"
                    style="
                      width: 191px;
                      height: 191px;
                      background-color: #00ebff65;
                      border: 1px solid #00f5ff;
                    "
                  ></div>
                </div>
              </div>
              <div class="mx-24 mt-16 thin-scrollbar" style="height: 335px">
                <div>
                  <div
                    v-if="!$utils('watchingTrim', ruleFormReward.names.en || '')"
                    class="bg-000000 bd-r-4 opa-03"
                    style="width: 154px; height: 18px"
                  ></div>
                  <div v-else class="fs-20 fw-900 fc-000000">
                    {{ ruleFormReward.names.en }}
                  </div>
                  <div
                    v-if="
                      !$utils(
                        'watchingTrim',
                        ruleFormReward.descriptions.en || ''
                      )
                    "
                    class="mt-6"
                  >
                    <div
                      class="bg-000000 bd-r-4 opa-01"
                      style="height: 18px"
                    ></div>
                    <div
                      class="bg-000000 bd-r-4 opa-01 mt-2"
                      style="height: 18px"
                    ></div>
                    <div
                      class="bg-000000 bd-r-4 opa-01 mt-2"
                      style="width: 180px; height: 18px"
                    ></div>
                  </div>
                  <div v-else class="fs-16 fw-400 fc-6C6C6C pre-line mt-6">
                    {{ ruleFormReward.descriptions.en }}
                  </div>
                </div>
                <div class="mt-30 flex-center" style="margin-top: 36px">
                  <div class="button-take-reward flex-mid">
                    <i class="el-icon-minus"></i>
                  </div>
                  <div class="opa-08 fs-20 mx-16">1</div>
                  <div class="button-take-reward flex-mid">
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <div
                  class="flex mb-26"
                  :style="`margin-top: ${
                    ruleFormReward.description_en ? '50' : '99'
                  }px;`"
                >
                  <div>
                    <div class="button-cencel-redeem flex-mid">
                      <i class="el-icon-close"></i>
                    </div>
                  </div>
                  <div>
                    <div class="button-redeem flex-mid cursor-default">
                      <div v-if="ruleFormReward.approval">
                        {{ $t("rewards.REQUEST") }}
                      </div>
                      <div v-else>{{ $t("rewards.REDEEM") }}</div>
                      <div class="mock flex-center">
                        <img
                          v-if="ruleFormReward.costSelected == 'coins'"
                          class="coin"
                          src="../assets/icons/ic_flat_coin.png"
                        />
                        <img
                          v-else
                          src="../assets/icons/ic_flat_gem.png"
                          class="coin"
                        />
                        <div
                          v-if="
                            $utils('watchingTrim', ruleFormReward.cost || '')
                          "
                          class="fs-18 fw-700 mt-2 ml-6"
                        >
                          {{ ruleFormReward.cost }}
                        </div>
                        <div
                          v-else
                          class="bg-FFFFFF opa-05 bd-r-4 ml-8"
                          style="width: 30px; height: 20px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right fc-000000">
            <div class="fs-20 fw-700">
              {{ dialogFormRewardRule === "edit" ? "Edit" : "Add" }} a Reward
            </div>
            <el-form
              :model="ruleFormReward"
              :rules="rules"
              ref="ruleForm"
              label-width="200px"
              class="demo-ruleForm"
            >
              <el-menu
                style="margin-left: 146px; border-bottom: solid 2px #e6e6e6"
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
              >
              <el-menu-item
              v-for="(item, index) in language"
                :key="index"
                :index="item.code" 
                style="padding-left: 0" >
                {{
                  item.text
                }}
              </el-menu-item>



                <!-- <el-menu-item style="padding-left: 0" index="1">{{
                  $t("rewards.english")
                }}</el-menu-item>
                <el-menu-item index="2" v-if="!engonly">{{
                  $t("rewards.thai")
                }}</el-menu-item> -->
              </el-menu>


              <div
              class="mt-24"
              style="margin-left: -55px"
              >
              <el-form-item :prop="`names.${activeIndex}`">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.names[activeIndex]"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.name_of_reward')"
                    required
                    :disabled="ruleFormReward.master"
                    @input="onInputNameEn"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C mr-4">*</span
                    >{{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.descriptions[activeIndex]"
                    class="dialogInput"
                    :placeholder="$t('rewards.description')"
                    required
                    :disabled="ruleFormReward.master"
                    rows="4"
                    @input="onInputDescEn"
                  ></el-input>
                </el-form-item>

              </div>
              




              <!-- <div
                v-if="activeIndex == '0'"
                class="mt-24"
                style="margin-left: -55px"
              >
                <el-form-item prop="name">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.name_en"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.name_of_reward')"
                    required
                    :disabled="ruleFormReward.master"
                    @input="onInputNameEn"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C mr-4">*</span
                    >{{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.description_en"
                    class="dialogInput"
                    :placeholder="$t('rewards.description')"
                    required
                    :disabled="ruleFormReward.master"
                    rows="4"
                    @input="onInputDescEn"
                  ></el-input>
                </el-form-item>
              </div>
              <div
                v-if="activeIndex == '1'"
                class="mt-24"
                style="margin-left: -55px"
              >
                <el-form-item prop="name">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.name"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.mame_of_reward_Thai')"
                    required
                    :disabled="ruleFormReward.master"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C">*</span>
                    {{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.description"
                    class="dialogInput"
                    required
                    :placeholder="$t('rewards.description_Thai')"
                    rows="4"
                    :disabled="ruleFormReward.master"
                  ></el-input>
                </el-form-item>
              </div> -->





              <div style="margin-left: -55px">
                <el-form-item prop="cost">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.cost")
                  }}</span>
                  <el-col :span="14">
                    <el-input
                      type="number"
                      :min="0"
                      v-model="ruleFormReward.cost"
                      @blur="checkCost"
                      auto-complete="off"
                      placeholder="0"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="10">
                    <div class="ml-12">
                      <el-select
                        v-model="ruleFormReward.costSelected"
                        :disabled="ruleFormReward.master"
                      >
                        <el-option
                          :label="$t('rewards.coins')"
                          value="coins"
                        ></el-option>
                        <el-option
                          :label="$t('rewards.gems')"
                          value="gems"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-col>
                </el-form-item>
                <el-form-item prop="duration">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.duration")
                  }}</span>
                  <el-date-picker
                    class="dialogInput"
                    v-model="ruleFormReward.duration"
                    type="daterange"
                    format="dd/MM/yyyy HH:mm"
                    range-separator="TO"
                    :start-placeholder="$t('rewards.start_date')"
                    :end-placeholder="$t('rewards.end_date')"
                    :disabled="ruleFormReward.master"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.settings")
                  }}</span>
                  <el-col :span="12">
                    <el-select
                      v-model="ruleFormReward.type"
                      placeholder="Type"
                      :disabled="ruleFormReward.master"
                    >
                    <el-option v-for="(item,index) in tagMaster" :key="index"
                        :label="$t(`rewards.${item.value}`)"
                        :value="index.toString()"
                      ></el-option>
                      <!-- <el-option
                        :label="$t('rewards.gift_cards')"
                        value="0"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.perks')"
                        value="3"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.team_building')"
                        value="team_building"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.doing_good')"
                        value="doing_good"
                      ></el-option> -->
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <div class="ml-12">
                      <el-select
                        v-model="ruleFormReward.country"
                        :placeholder="$t('rewards.country')"
                        :disabled="ruleFormReward.master"
                      >
                        <el-option
                          :label="$t('rewards.all_countries')"
                          value="All Countries"
                        ></el-option>
                        <el-option
                          v-for="item in optionsCountry"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.limited_qty")
                  }}</span>
                  <div class="flex-center">
                    <div
                      class="relative switch-contrainer-small"
                      :class="{ 'border-blue': ruleFormReward.quantity }"
                    >
                      <input
                        type="checkbox"
                        id="checkbox"
                        class="input-checkbox"
                        v-model="ruleFormReward.quantity"
                      />
                      <label for="checkbox" class="lable-checkbox">{{
                        ruleFormReward.quantity
                      }}</label>
                    </div>
                    <div
                      class="ml-16 fs-16 fc-4A4A4A flex-center"
                      style="height: 44px"
                    >
                      <span v-if="ruleFormReward.quantity"
                        >{{ this.ruleFormReward.quantityLimits }}
                        {{ $t("rewards.available") }}</span
                      >
                      <span v-else>{{ $t("rewards.no_limit") }}</span>
                    </div>
                    <div
                      v-if="ruleFormReward.quantity"
                      class="ml-auto flex-center"
                    >
                      <div
                        @mousedown="startHold(1)"
                        @touchstart="startHold(1)"
                        @mouseleave="stopHold"
                        @mouseup="stopHold"
                        @touchend="stopHold"
                        @touchcancel="stopHold"
                        class="cursor-pointer button-quantity center mr-12"
                      >
                        <i class="el-icon-plus"></i>
                      </div>
                      <div
                        @mousedown="startHold(-1)"
                        @touchstart="startHold(-1)"
                        @mouseleave="stopHold"
                        @mouseup="stopHold"
                        @touchend="stopHold"
                        @touchcancel="stopHold"
                        class="cursor-pointer button-quantity center"
                      >
                        <i class="el-icon-minus"></i>
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.Require_Approval")
                  }}</span>
                  <div class="flex-center">
                    <div
                      class="relative switch-contrainer-small"
                      :class="{ 'border-blue': ruleFormReward.approval }"
                    >
                      <input
                        type="checkbox"
                        id="checkboxApproval"
                        class="input-checkbox"
                        v-model="ruleFormReward.approval"
                      />
                      <label for="checkboxApproval" class="lable-checkbox">{{
                        ruleFormReward.approval
                      }}</label>
                    </div>
                    <div class="fs-16 fc-4A4A4A ml-16">
                      <span v-if="ruleFormReward.approval">
                        {{ $t("rewards.On") }}
                      </span>
                      <span v-else>
                        {{ $t("rewards.Off") }}
                      </span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.image")
                  }}</span>
                  <div class="flex-center">
                    <el-upload
                      action
                      :http-request="addImage"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                    >
                      <div
                        class="button-upload flex-mid"
                        :class="`${
                          ruleFormReward.master ? 'button-disable' : ''
                        }`"
                      >
                        {{ $t("rewards.upload") }}
                      </div>
                    </el-upload>
                    <div class="ml-16">
                      <div
                        class="fs-12 fc-000000"
                        style="line-height: 14px; word-break: break-word"
                      >
                        {{ $t("rewards.file_size_should") }}
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-form>

            <div style="margin-left: 145px" class="mt-32">
              <span slot="footer">
                <el-button
                  v-if="dialogFormRewardRule == 'edit'"
                  class="btn-add bigger"
                  type="primary"
                  @click="submitReward('edit')"
                  >{{ $t("global.SAVE") }}</el-button
                >
                <el-button
                  v-else
                  class="btn-add bigger"
                  type="primary"
                  @click="submitReward('add')"
                  >{{ $t("global.ADD") }}</el-button
                >
                <el-button class="btn-cancel bigger" @click="clearRewardFrom">{{
                  $t("global.CANCEL")
                }}</el-button>
                <el-button
                  v-if="
                    dialogFormRewardRule == 'edit' &&
                    ruleFormReward.master == false
                  "
                  class="btnDeleteDialog bigger"
                  type="danger"
                  @click="deleteReward"
                  >{{ $t("global.DELETE") }}</el-button
                >
              </span>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <el-dialog :visible.sync="dialogFormRedeemed" width="960px" top="5vh">
      <span slot="title"></span>
      <div>
        <div class="pl-40 pr-40 pt-40 pb-16 bg-activity">
          <div class="fc-000000 fs-20 fw-700">Reward Activity</div>
          <div style="height: 180px">
            <canvas
              ref="rewardActivityBarchart"
              height="180px"
              class="barchart-style"
            ></canvas>
          </div>
        </div>
        <div class="pl-40 pr-40">
          <div class="flex-center pt-24">
            <div class="" style="width: 200px">
              <el-menu class="input-select" mode="horizontal">
                <el-submenu index="1" style="width: 200px">
                  <template slot="title">
                    <span class="text-dropdown">{{ selectMonth ? selectMonth : start_month }}</span>
                  </template>
                  <div class="scroll-style thin-scrollbar">
                    <el-menu-item
                      v-bind:key="index"
                      v-for="(item, index) in list_month"
                      index="1"
                      @click="monthClick(item.num_month, item.label_month)"
                      >{{ item.label_month }}</el-menu-item
                    >
                  </div>
                </el-submenu>
              </el-menu>
            </div>
            <div @click="exportTable" class="btn-6C30CC btn btn-export ml-16">
              Export
            </div>
          </div>
        </div>
        <span class="fs-2">&nbsp;</span>
        <div class="thin-scrollbar pl-30 mr-12">
          <el-table
            id="redeemedTable"
            :data="redeemed"
            :default-sort="{ prop: 'name', order: 'ascending' }"
            size="small"
            max-height="334px"
            :empty-text="showTextLoading"
          >
            <el-table-column
              prop="reward"
              :label="$t('rewards.Reward')"
              height="10px"
              width="160px"
            >
              <template slot-scope="scope">
                <div class="flex-center fc-000000">
                  <span class="fs-14 fw-500 ellipsis">{{
                    scope.row.reward
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="user"
              :label="$t('rewards.Recipient')"
              width="240px"
            >
              <template slot-scope="scope">
                <!-- <div class="flex-center">
                  <span
                    class
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >{{ scope.row.user
                    }}{{
                      scope.row.send_to != ""
                        ? " (" + scope.row.send_to + ")"
                        : ""
                    }}</span
                  >
                </div> -->
                <div class="flex-row-between">
                  <div class="recipient-user-box flex-center"
                  :class="{ 'blurelement': blurMode }">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-32 flex-mid"
                    />
                    <div v-else class="image image-profile-32 flex-mid bg-primary-light">
                      <div class="text-in-image text-in-image-32 flex-mid fc-primary">
                        {{
                          $utils("acronymName", {
                            fullName: scope.row.send_to,
                          })
                        }}
                      </div>
                    </div>
                    <div class="ml-8 fc-000000" style="line-height: 16px">
                      <div class="fs-14 fw-500 ellipsis" style="max-width: 200px;">{{ scope.row.send_to }}</div>
                      <div class="fs-13 opa-06 ellipsis" style="max-width: 200px;">{{ scope.row.team }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="email"
              header-align="right"
              align="right"
              label="Value"
              width="80"
            >
              <template slot-scope="scope">
                <div class="flex-center right fc-000000">
                  <div
                    class="fs-14 fw-500 ellipsis ml-auto"
                    style="white-space: nowrap"
                  >
                    {{ scope.row.symbol+scope.row.value }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Type" width="90">
              <template slot-scope="scope">
                <div class="flex-center fc-000000">
                  <span
                    class="fs-14 fw-500 ellipsis"
                    style="white-space: nowrap"
                    >{{ "Reward" }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="date"
              header-align="right"
              align="right"
              label="Date & Time"
              width="190"
            >
              <template slot-scope="scope">
                <div class="flex-center fc-000000">
                  <div class="fs-14 fw-500 ellipsis ml-auto">
                    {{ scope.row.date }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              :label="$t('rewards.status')"
              width="130"
            >
              <template slot-scope="scope">
                <div class="flex-center" style="width: 110px">
                  <div class="mr-auto">
                    <span
                      class="span-status-tag tag-processing"
                      v-if="scope.row.status == 'N'"
                    >
                      {{ $t("rewards.processing") }}
                    </span>
                    <span
                      class="span-status-tag tag-processing"
                      v-if="scope.row.status == 'P'"
                    >
                      {{ $t("rewards.processing") }}
                    </span>
                    <span
                      class="span-status-tag tag-delivered"
                      v-if="scope.row.status == 'Y'"
                    >
                      {{ $t("rewards.Delivered") }}
                    </span>
                    <span
                      class="span-status-tag tag-cancel"
                      v-if="scope.row.status == 'X'"
                    >
                      {{ $t("rewards.cancel") }}
                    </span>
                    <span
                      class="span-status-tag tag-refund"
                      v-if="scope.row.status == 'C'"
                    >
                      {{ $t("rewards.refund") }}
                    </span>
                  </div>
                  <el-dropdown v-if="scope.row.check_rewards_company" :disabled="scope.row.check_disable">
                    <span class="el-dropdown-link">
                      <img
                        :src="$utils('icons', 'edit_black_24dp')"
                        alt="icons_edit_black_24dp"
                        :class="{ 'opa-02': scope.row.check_disable }"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="scope.row.status != 'P'"
                        ><div @click="redeemedClick(scope.row, 'P')">
                          {{ $t("rewards.processing") }}
                        </div></el-dropdown-item
                      >
                      <el-dropdown-item v-if="scope.row.status != 'Y'"
                        ><div @click="redeemedClick(scope.row, 'Y')">
                          {{ $t("rewards.sent") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'X'"
                        ><div @click="redeemedClick(scope.row, 'X')">
                          {{ $t("rewards.cancel") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'C'"
                        ><div @click="redeemedClick(scope.row, 'C')">
                          {{ $t("rewards.refund") }}
                        </div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown v-else :disabled="scope.row.check_disable">
                    <span class="el-dropdown-link">
                      <img
                        :src="$utils('icons', 'edit_black_24dp')"
                        alt="icons_edit_black_24dp"
                        :class="{ 'opa-02': scope.row.check_disable }"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="scope.row.status != 'X'"
                        ><div @click="redeemedClick(scope.row, 'X')">
                          {{ $t("rewards.cancel") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'C'"
                        ><div @click="redeemedClick(scope.row, 'C')">
                          {{ $t("rewards.refund") }}
                        </div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-menu
                    :default-active="activeIndex"
                    mode="horizontal"
                    close="ml-auto"
                    id="hide-arrow-menu"
                    style="border-bottom: none"
                  >
                    <el-submenu
                      index="1"
                      v-bind:disabled="scope.row.check_disable"
                    >
                      <template slot="title">
                        <span>
                          <img
                            :src="$utils('icons', 'edit_black_24dp')"
                            alt="icons_edit_black_24dp"
                          />
                        </span>
                      </template>
                      <el-menu-item
                        index="1-2"
                        v-if="scope.row.status != 'P'"
                        @click="redeemedClick(scope.row.id, 'P')"
                        >{{ $t("rewards.processing") }}</el-menu-item
                      >
                      <el-menu-item
                        index="1-3"
                        v-if="scope.row.status != 'Y'"
                        @click="redeemedClick(scope.row.id, 'Y')"
                        >{{ $t("rewards.sent") }}</el-menu-item
                      >
                      <el-menu-item
                        index="1-4"
                        v-if="scope.row.status != 'X'"
                        @click="redeemedClick(scope.row.id, 'X')"
                        >{{ $t("rewards.cancel") }}</el-menu-item
                      >
                    </el-submenu>
                  </el-menu> -->
                </div>
              </template>
            </el-table-column>
            <template slot="append">
              <div v-show="loadmore_ck">
                <infinite-loading
                  :on-infinite="loadmore"
                  force-use-infinite-wrapper=".el-table__body-wrapper"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <!-- <el-button
          @click="dialogFormRedeemed = false"
          style="
            margin-right: 26px;
            color: #939393;
            margin-top: 8px;
            font-weight: bold;
            width: 86px;
          "
          >{{ $t("global.close") }}</el-button
        > -->
      </span>
    </el-dialog>

    <el-dialog :visible.sync="statusConfirmModal" width="600px">
      <div class="fc-000000">
        <div class="m-20 pt-40 fs-20 fw-700">
          <i class="el-icon-warning" style="color: orange"></i>
          {{ $t("rewards.confirm_cancellation") }}
        </div>
        <div class="mx-20 fs-16" style="word-break: break-word">
          {{ $t("rewards.are_you_sure") }}
          <span class="fw-700">{{ confirmModalData.nameOfReward }}</span>
          {{ $t("rewards.redeemed_by") }}
          <span class="fw-700"
            >{{ confirmModalData.firsname }}
            {{ confirmModalData.lastname }}?</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.no")
        }}</el-button>
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.yes_and_refund")
        }}</el-button>
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.yes_and_do")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//const moment = require('moment-timezone')
import Chart from "chart.js/auto";
import InfiniteLoading from "vue-infinite-loading";
import format from "date-fns/format";

export default {
  name: "rewards",
  components: {
    InfiniteLoading,
    loadingEven: require("./even/loading").default,
  },
  created() {
    this.$store.dispatch("reward/getTagMaster");
    this.$store.dispatch("reward/getRewardsMaster");
    this.$store.dispatch("reward/checkEngOnly");
    this.$store.dispatch("reward/getCountry");
    this.$store.dispatch("reward/getAllrewards_db", this.user);
    // this.$store.commit("reward/setTab", "0");
    this.$store.dispatch("reward/getRewards", this.user);
    this.$store.commit("authen/setActiveIndex", "5");
    this.$store.dispatch("reward/getList_month", this.user);
    this.$store.dispatch("reward/getAlluser", this.user);
    this.$store.dispatch("reward/getAllrewards_company", this.user);
    this.$store.dispatch("reward/getProcessingRedeemed", this.user);
    // var moonLanding = new Date();
    // var cur_month = moonLanding.getMonth();
    // cur_month = cur_month + 1;
    // if (parseInt(cur_month) < 10) {
    //   cur_month = "0" + cur_month;
    // }
    // var cur_year = moonLanding.getFullYear();
    // var cur_start = cur_year + "-" + cur_month;
    // this.selectnum = cur_start;
    // this.$store.dispatch("reward/getRedeemed", [this.user, cur_start]);
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["reward/inputSearch"];
      },
      set(value) {
        this.$store.commit("reward/setinputSearch", { value });
      },
    },
    engonly() {
      return this.$store.getters["reward/engonly"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    rewards() {
      this.loadingRewardsTable = ++this.loadingRewardsTable;
      return this.$store.getters["reward/rewards"];
    },
    rewardsemptytext() {
      return this.$store.getters["reward/rewardsemptytext"];
    },
    showTextLoading() {
      return this.$store.getters["reward/showTextLoading"];
    },
    redeemed() {
      return this.$store.getters["reward/redeemed"];
    },
    countrewards() {
      return this.$store.getters["reward/countrewards"];
    },
    list_month() {
      return this.$store.getters["reward/list_month"];
    },
    start_month() {
      return this.$store.getters["reward/start_month"];
    },
    loadmore_ck() {
      return this.$store.getters["reward/loadmore"];
    },
    badgeRedeemed() {
      return this.$store.getters["reward/processingRedeemed"];
    },
    optionsCountry() {
      return this.$store.getters["reward/country"];
    },
    dataChart(){
      return this.$store.getters["reward/dataChart"];
    },
    companySymbol() {
      return this.$store.getters["reward/companySymbol"];
    },
    tagMaster() {
      return this.$store.getters["reward/tagMaster"];
    },
    rewardsMasterData() {
      return this.$store.getters["reward/rewardsMasterData"];
    },
    language() {
      return this.$store.getters["reward/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    countNewReward(){
      return this.$store.getters["reward/countNewReward"];
    }
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("reward/searchRewards", this.inputSearch);
    },
    dataChart(){
      setTimeout(() => {
          this.randerBarChartRewardActivity();
      }, 300)
    },
    dialogFormRedeemed(value) {
      if (value) {
        if (this.reward_activity_bar_chart) {
          this.reward_activity_bar_chart.destroy();
        }
        // setTimeout(() => {
        //   this.randerBarChartRewardActivity();
        // }, 300);
      }
    },
    language(){
      for(const i in this.language){
        if(!this.rules[`names.${this.language[i].code}`]){
          this.rules[`names.${this.language[i].code}`] = [
            { required: true, message: `Please input the ${this.language[i].text} name`, trigger: 'blur' }
          ]
        }
        
      }
    },

  },
  data() {
    return {
      activeIndex:'en',
      id: "",
      company: "",
      mode: "",
      selectStatus: "Show All Status",
      selectMonth: "",
      selectnum: format(new Date(),"YYYY-MM"),
      tab: "0",
      anchor: {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
      },
      width: "",
      title_dialog: "",
      dialogFormVisible: false,
      dialogFormEdit: false,
      dialogFormRedeemed: false,
      formLabelWidth: "120px",
      imageUrl: "",
      value4: "",
      status: "all",
      loadmord: 1,
      ruleForm: {
        names:{},
        name: "",
        name_en: "",
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "3",
        qty: "",
        filename: "",
        file: [],
        master: false,
      },
      dialogFormReward: false,
      intervalHolding: false,
      dialogFormRewardRule: "add",
      ruleFormReward: {
        name: "",
        name_en: "",
        names:{},
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "0",
        qty: "",
        filename: "",
        file: [],
        master: false,
        country: "All Countries",
        quantity: false,
        quantityLimits: 0,
        quantityLimitsMaster: 0,
      },
      rules: {
        'names.en': [
          { required: true, message: 'Please input the English name', trigger: 'blur' },
        ],
        name: [
          {
            required: true,
            message: "Please input name of reward in all active languages",
            trigger: "blur",
          },
        ],
        duration: [
          {
            type: "array",
            required: true,
            message: "Please pick a date",
            trigger: "change",
          },
        ],
        cost: [
          {
            required: true,
            message: "Please input cost of reward",
            trigger: "blur",
          },
        ],
        coins: [
          {
            required: true,
            message: "Please input amount of coins",
            trigger: "blur",
          },
        ],
        gems: [
          {
            required: true,
            message: "Please input amount of gems",
            trigger: "blur",
          },
        ],
      },
      btnSave: "",
      btnDelete: "",
      enabled_instant: true,
      loadingRewardsTable: -1,
      statusConfirmModal: false,
      confirmModalData: {
        nameOfReward: "Name of Reward",
        firsname: "Firstname",
        lastname: "Lastname",
      },
      oldtab:0
    };
  },
  mounted() {
        
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.tab = params;
      this.$store.commit("reward/setTab", this.tab);
      this.$store.commit("reward/setinputSearch", "");
      this.$store.dispatch("reward/getRewards", this.user);
    } else {
      if (this.$route.query.welcome == "true") {
        this.$router.push({
          name: "rewards",
          params: { tab: "0" },
          query: { welcome: "false" },
        });
      } else {
        this.$router.push({ name: "rewards", params: { tab: "0" } });
      }
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "rewards") {
        item.name = item.tab;
        this.handleClick(item);
      }
    });
  },
  beforeDestroy(){
    // console.log('beforeDestroy')
    this.$store.dispatch("reward/setOldReward",0);
  },
  methods: {
    onInputNameEn(text) {

      if (this.engonly) {
        this.ruleFormReward.names[this.activeIndex] = text;
      }
    },
    onInputDescEn(text) {
      if (this.engonly) {

        this.ruleFormReward.descriptions[this.activeIndex] = text;
      }
    },
    handleBlock(item) {
      this.$store.dispatch("reward/blockReward", item);
    },
    loadmore($state) {
      if (this.loadmore_ck == true) {
        var moonLanding = new Date();
        var cur_month = moonLanding.getMonth();
        this.$store.dispatch("reward/getRedeemed_loadmore", [
          this.user,
          cur_month + 1,
        ]);
        setTimeout(() => {
          $state.loaded();
        }, 2000);
      } else {
        $state.complete();
      }
    },
    handleClick(tab, event) {
      console.log('tab',this.tab)
      console.log('oldtab',this.oldtab)
      const tabName = tab.name || "";
      this.tab = tabName;
      this.loadingRewardsTable = -1;
      const paramsTab = this.$router.currentRoute.params.tab;
      if (paramsTab != tabName) {
        this.$router.push({ name: "rewards", params: { tab: tabName } });
      }
      this.$store.commit("reward/setTab", this.tab); 
      this.$store.commit("reward/setinputSearch", "");
      this.$store.dispatch("reward/setOldReward",this.oldtab);
      this.$store.dispatch("reward/getRewards", this.user);
      this.oldtab = this.tab;
    },
    handleActivate(index, item) {
      this.$confirm(
        `Are you sure you would like to activate this reward?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/activateReward", item);
          this.$message({
            type: "success",
            message: "Reward activated",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    handleDisable(index, item) {
      this.$confirm(
        `Are you sure you would like to disable this reward?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/disableReward", item);
          this.$message({
            type: "success",
            message: "Reward disabled",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    statusClick(type) {
      const opt = [];
      opt["Active"] = "Y";
      opt["Inactive"] = "N";
      opt["Show All"] = "all";
      let txt = ''
      if(type == "Show All"){
        txt='Show All Status'
      }else if(type == "Active"){
        txt='Enabled'
      }else if(type == "Inactive"){
        txt='Disabled'
      }
      this.selectStatus = txt;
      this.status = opt[type];
      this.$store.commit("reward/setselectShow", { type: opt[type] });
      this.$store.dispatch("reward/selectStatus", this.status);
    },
    monthClick(num, label) {
      this.$store.commit("reward/setLoadmore", false);
      this.selectMonth = label;

      if (num != "-6" && num != "all" && num != "-3") {
        if (parseInt(num) < 10) {
          num = "0" + num;
        }
        var label = label.split(" ");
        num = label[1] + "-" + num;
      }

      this.selectnum = num;
      this.$store.dispatch("reward/getRedeemedSelectMonth", [this.user, num]);
    },
    redeemedClick(row, status) {
      let id = row.id
      var _this = this;
      let txt = ''
      let txt_complete = ''
      if(status == 'X'){
        txt = 'Are you sure you would like to cancel this reward transaction?'
        txt_complete = 'The reward has been successfully canceled'
      }else if(status == 'C'){
        txt = `Are you sure you would like to cancel this reward transaction? The coins or gems will be refunded to ${row.user}.`
        txt_complete = 'The reward has been successfully canceled'
      }else{
        txt = 'Are you sure to you want to change the status of item?'
        txt_complete = 'Status updated'
      }
      this.$confirm(
        `${txt}`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/redeemed_change", [
            id,
            status,
            this.user,
            this.selectnum,
          ]);
          this.$store.dispatch("reward/getProcessingRedeemed", this.user);
          this.$message({
            type: "success",
            message: `${txt_complete}`,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    addReward() {
      this.title_dialog = this.$t("rewards.add_a_reward");
      this.mode = "";
      this.dialogFormVisible = true;
      this.imageUrl = "";
      this.btnSave = "ADD";
      this.ruleForm = {
        names: {},
        name: "",
        name_en: "",
        descriptions: {},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "3",
        qty: "",
        filename: "",
        file: [],
        master: false,
      };
      this.ruleFormReward= {
        name: "",
        name_en: "",
        names:{},
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "0",
        qty: "",
        filename: "",
        file: [],
        master: false,
        country: "All Countries",
        quantity: false,
        quantityLimits: 0,
        quantityLimitsMaster: 0,
      }
    },
    editReward(index, item) {
      this.title_dialog = "Edit a Reward";
      this.dialogFormEdit = true;
      if (item.img) {
        this.imageUrl = item.img;
      }
      this.id = item.key;
      this.company = item.company;
      this.btnSave = this.$t("global.SAVE");
      this.btnDelete = "DELETE";
      this.mode = "edit";
      let endon = "";
      let starton = "";
      if (item.endon !== undefined) {
        const d1 = item.endon.split(" ");
        const date1 = d1[0].split("/");
        const time1 = d1[1].split(":");
        endon =
          date1[2] +
          "-" +
          date1[1] +
          "-" +
          date1[0] +
          " " +
          time1[0] +
          ":" +
          time1[1];

        const d = item.starton.split(" ");
        const date = d[0].split("/");
        const time = d[1].split(":");
        starton =
          date[2] +
          "-" +
          date[1] +
          "-" +
          date[0] +
          " " +
          time[0] +
          ":" +
          time[1];
      }
      this.ruleForm = {
        name: item.reward,
        name_en: item.reward_en,
        description: item.description,
        description_en: item.description_en,
        costSelected: item.gems > 0 ? "gems" : "coins",
        cost: item.gems > 0 ? item.gems : item.coins,
        duration: [
          format(starton, "MM-DD-YYYY HH:mm"),
          format(endon, "MM-DD-YYYY HH:mm"),
        ],
        type: item.type,
        qty: item.qty === 0 ? "" : item.qty,
        filename: item.filename,
        file: [],
        master: item.edit === "N" ? true : false,
        quantityLimits: item.limit ? item.limit : 0,
        quantity: item.limit ? true : false,
      };
    },
    handleSelect(key, keyPath) {
      
      this.activeIndex = key;
    },
    openRedeemed() {
      this.$store.dispatch("reward/getRedeemedChart");


      this.dialogFormRedeemed = true;
      this.title_dialog = "Redeemed Rewards";
      this.mode = "";
      this.imageUrl = "";
      this.btnSave = "Add";
      this.ruleForm = {};
    },
    async submitReward(mode) {
      this.$refs["ruleForm"].validate((valid) => {
        if (mode != "edit") {
          if (this.ruleFormReward.file.length == 0) {
            this.$message({
              type: "error",
              message: "Please select an image",
            });
            valid = false;
          }
        }
        if (valid) {
          if (mode == "edit") {
            const data = this.ruleFormReward;
            data["key"] = this.id;
            console.log("edit",data)
            this.$store.dispatch("reward/updateReward", data).then(() => {
              this.dialogFormReward = false;
              this.update_success();
            });
          } else {
            console.log("createReward",this.ruleFormReward)
            this.$store
              .dispatch("reward/createReward", this.ruleFormReward)
              .then(() => {
                this.dialogFormReward = false;
                this.update_success();
              });
          }
        } else {
          return false;
        }
      });
    },
    editRewardNew(index, item) {
      //console.log('item',item)
      this.dialogFormRewardRule = "edit";
      if (item.img) {
        this.imageUrl = item.img;
      }
      this.id = item.key;
      this.company = item.company;
      let endon = "";
      let starton = "";
      if (item.endon !== undefined) {
        const d1 = item.endon.split(" ");
        const date1 = d1[0].split("/");
        const time1 = d1[1].split(":");
        endon =
          date1[2] +
          "-" +
          date1[1] +
          "-" +
          date1[0] +
          " " +
          time1[0] +
          ":" +
          time1[1];

        const d = item.starton.split(" ");
        const date = d[0].split("/");
        const time = d[1].split(":");
        starton =
          date[2] +
          "-" +
          date[1] +
          "-" +
          date[0] +
          " " +
          time[0] +
          ":" +
          time[1];
      }
      //if(item.country)
      this.ruleFormReward = {
        names:item.names,
        name: item.reward,
        name_en: item.reward_en,
        descriptions:item.descriptions,
        description: item.description,
        description_en: item.description_en,
        costSelected: item.gems > 0 ? "gems" : "coins",
        cost: item.gems > 0 ? item.gems : item.coins,
        duration: [
          format(starton, "MM-DD-YYYY HH:mm"),
          format(endon, "MM-DD-YYYY HH:mm"),
        ],
        // type: item.type,
        type: item.tag_value,
        qty: "", // space for set default
        filename: item.filename,
        file: [],
        master: item.edit === "N" ? true : false,
        country: item.country ? item.country : "All Countries",
        quantityLimits: 0, // 0 for set default
        quantityLimitsMaster: (this.rewardsMasterData[item.key] && this.rewardsMasterData[item.key].qty > 0)  ? this.rewardsMasterData[item.key].qty : 0,
        quantity: item.promotion == "Y" ? true : false,
        approval: item.approval_reward == "Y" ? true : false,
      };
      if(item.qty && item.qty > 0){
        if(item.used && item.used > 0){
          this.ruleFormReward.qty = item.qty - item.used
        }else{
          this.ruleFormReward.qty = item.qty
        }
      }else{
        this.ruleFormReward.qty = ""
      }
      if(this.ruleFormReward.quantityLimitsMaster > 0){
        if(this.ruleFormReward.qty && this.ruleFormReward.qty > 0){
          if(this.ruleFormReward.qty > this.ruleFormReward.quantityLimitsMaster){
            this.ruleFormReward.quantityLimits = this.ruleFormReward.quantityLimitsMaster
          }else{
            this.ruleFormReward.quantityLimits = this.ruleFormReward.qty
          }
        }else{
          this.ruleFormReward.quantityLimits = this.ruleFormReward.quantityLimitsMaster
        }
      }else{
        this.ruleFormReward.quantityLimits = this.ruleFormReward.qty ? this.ruleFormReward.qty : 0
      }
      this.dialogFormReward = true;
    },
    clearRewardFrom() {
      this.ruleFormReward.names = {};
      this.ruleFormReward.name = "";
      this.ruleFormReward.name_en = "";
      this.ruleFormReward.descriptions = {};
      this.ruleFormReward.description = "";
      this.ruleFormReward.description_en = "";
      this.ruleFormReward.costSelected = "coins";
      this.ruleFormReward.cost = "";
      this.ruleFormReward.coins = "";
      this.ruleFormReward.gems = "";
      this.ruleFormReward.duration = [];
      this.ruleFormReward.type = "0";
      this.ruleFormReward.qty = "";
      this.ruleFormReward.filename = "";
      this.ruleFormReward.file = "";
      this.ruleFormReward.master = false;
      this.ruleFormReward.country = "All Countries";
      this.dialogFormReward = false;
      this.imageUrl = null;
      this.dialogFormRewardRule = "add";
      this.ruleFormReward.quantityLimitsMaster = 0;
      (this.ruleFormReward.quantityLimits = 0),
        (this.ruleFormReward.quantity = false);
      this.ruleFormReward.approval = false;
    },
    addImage(file, fileList) {
      this.ruleFormReward.file = [];
      this.ruleFormReward.file.push(file.file);
      this.imageUrl = URL.createObjectURL(file.file);
    },
    saveReward() {
      this.$refs["ruleForm"].validate((valid) => {
        if (this.mode != "edit") {
          if (this.ruleForm.file.length == 0) {
            valid = false;
          }
        }

        if (valid) {
          if (this.mode == "edit") {
            const data = this.ruleForm;
            data["key"] = this.id;
            this.$store.dispatch("reward/updateReward", data);
          } else {
            this.$store.dispatch("reward/createReward", this.ruleForm);
          }
          this.update_success();
          this.dialogFormEdit = false;
        } else {
          return false;
        }
      });
    },
    deleteReward() {
      const data = this.ruleFormReward;
      data["key"] = this.id;

      this.$confirm(`Are you sure you want to delete this reward?`, "Warning", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("reward/deleteReward", data);
          this.$message({
            type: "success",
            message: "Reward Deleted",
          });
          this.clearRewardFrom();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    cancelEditReward() {
      this.dialogFormEdit = false;
      this.clearRewardFrom();
      this.$refs["ruleForm"].clearValidate();
    },
    cancelReward() {
      this.dialogFormVisible = false;
      this.clearRewardFrom();
      this.$refs["ruleForm"].clearValidate();
    },

    update_success() {
      let message = "Reward successfully added";
      if (this.mode == "edit") {
        message = "Reward updated";
      }

      //this.cancelReward();
      this.$message({
        type: "success",
        message,
      });
    },
    addAttachment(file, fileList) {
      this.ruleForm.file = [];
      this.ruleForm.file.push(file.file);
      this.imageUrl = URL.createObjectURL(file.file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("Avatar picture must be JPG format!");
      }
      if (!isLt2M) {
        this.$message.error("Avatar picture size can not exceed 2MB!");
      }
      return isJPG && isLt2M;
    },
    checkCost() {
      this.$refs["ruleForm"].clearValidate();
    },
    startHold(value) {
      if (!this.intervalHolding) {
        this.intervalHolding = setInterval(
          () => this.quantityLimits(value),
          60
        );
      }
    },
    stopHold() {
      clearInterval(this.intervalHolding);
      this.intervalHolding = false;
    },
    quantityLimits(value) {
      let limit = this.ruleFormReward.quantityLimits + value;
      if(this.ruleFormReward.quantityLimitsMaster > 0){
        if(limit > 0){
          if(limit <= this.ruleFormReward.quantityLimitsMaster) {
            this.ruleFormReward.quantityLimits = limit;
          }
        }else{
          this.ruleFormReward.quantityLimits = 0;
        }
      }else{
        if(limit > 0) {
          this.ruleFormReward.quantityLimits = limit;
        } else {
          this.ruleFormReward.quantityLimits = 0;
        }
      }
    },
    exportTable() {
      console.log("exportTable");
      this.$store.dispatch("reward/exportTable",this.selectnum);
    },
    randerBarChartRewardActivity() {
      var rewardActivityBarchart = this.$refs.rewardActivityBarchart;
      const months = this.dataChart.label_month
      // [
      //   "SEP",
      //   "OCT",
      //   "NOV",
      //   "DEC",
      //   "JAN",
      //   "FEB",
      //   "MAR",
      //   "APR",
      //   "MAY",
      //   "JUN",
      //   "JUL",
      //   "AUG",
      //   "SEP",
      // ];
      const month_years =this.dataChart.label_month_year
      //  [
      //   "SEP 2021",
      //   "OCT 2021",
      //   "NOV 2021",
      //   "DEC 2021",
      //   "JAN 2022",
      //   "FEB 2022",
      //   "MAR 2022",
      //   "APR 2022",
      //   "MAY 2022",
      //   "JUN 2022",
      //   "JUL 2022",
      //   "AUG 2022",
      //   "SEP 2022",
      // ];
      const disable_tooltip = [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ];
      // 242 => 1% of max value in this array!
      const value =this.dataChart.data 
      // [
      //   242, 242, 242, 242, 242, 242, 242, 242, 242, 23000.0, 19700.08, 26050.2,
      //   24200.00,
      // ];
      if (rewardActivityBarchart) {
        // this.loadingChartStatus = false;
        const rewardActivityBarChartData = {
          labels:  this.dataChart.label_month,
          datasets: [
            {
              label: this.companySymbol,
              data: value,
              months_years: month_years,
              disable_tooltip: disable_tooltip,
              backgroundColor: "#6C30CC",
              borderColor: "#6C30CC",
              borderWidth: 1,
              datalabels: {
                color: "#000",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.datasets.bar = {
          categoryPercentage: 0.5,
          borderRadius: 0,
        };
        options.scales.x = {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            textStrokeWidth: 1,
            font: {
              weight: "500",
            },
          },
        };
        options.layout = {
          padding: {
            top: 24,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          filter: function (tooltipItems) {
            const value = tooltipItems.dataset.disable_tooltip[
              tooltipItems.dataIndex
              ] || false
            return value;
          },
          callbacks: {
            title: (tooltipItems) => {
              if (tooltipItems.length != 0) {
                return (
                  tooltipItems[0].dataset.months_years[
                    tooltipItems[0].dataIndex
                  ] || ""
                );
              }
              return ""
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              const value = tooltipItems.formattedValue;
              let str = value.toString().split(".");
              if (str[0].length >= 4) {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
              }
              if (str[1]) {
                if (str[1] === "0") {
                  str = str[0] + ".00";
                } else if (str[1].length < 2) {
                  str = str.join(".");
                  str = str + "0";
                } else {
                  str = str.join(".");
                }
              } else {
                str = str[0] + ".00";
              }
              return `${label} ${str}`;
            },
          },
        };
        this.reward_activity_bar_chart = new Chart(
          rewardActivityBarchart.getContext("2d"),
          {
            type: "bar",
            data: rewardActivityBarChartData,
            options: options,
          }
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-style {
  max-height: 58vh;
  padding-bottom: 1px;
}
.bg-activity {
  background-color: rgba(#6c30cc, 0.05);
}
.button-quantity {
  width: 94px;
  height: 40px;
  font-size: 18px;
  padding-top: 4px;
  background-color: #d0d0d0;
}
.txtOptioRedeemed {
  color: #4a4a4a;
  font-size: 16px;
  margin-left: 16px;
}
.divTitle {
  width: 70px;
  height: 50px;
  background: #dbdbdb;
}
.divDescribe {
  margin-left: 32px;
  margin-top: 14px;
}
.divContentReward {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.inputSearchStyle {
  width: 320px;
  margin-left: 48px;
  margin-top: 35px;
}
.menuOptionStyle {
  background: #f4f4f4;
  border-bottom: transparent;
  border-radius: 4px;
  margin-top: 35px;
  margin-right: 48px;
}
.menuOptionStyleRedeemed {
  border: 1px solid;
  width: 200px;
  border-color: #c7c7c7;
  border-radius: 4px;
  height: 48px;
}
.divTable {
  flex: 1;
  margin-left: 48px;
  margin-right: 48px;
}
.img-rewards {
  width: 70px;
  height: 45px;
  object-fit: cover;
}
.button {
  width: 95px;
  font-size: 13px;
  font-weight: 700;
}
.buttonEdit {
  width: 66px;
  height: 42px;
  font-size: 15px;
  font-weight: 700;
}
.buttonTitle {
  margin-left: 15px;
  font-weight: 700;
  font-size: 18px;
  width: 160px;
  height: 52px;
  background: #32c2d5;
  border: 1px solid #32c2d5;
}
.buttonRedeemed {
  margin-left: 24px;
  font-weight: 700;
  font-size: 18px;
  height: 52px;
  width: 132px;
}
.avatar-uploader,
.avatar-uploader-error {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  height: 200px;
  background: #e3e3e3;
  border-radius: 2px 2px 0 0;
}
.avatar-uploader-error {
  border-style: solid;
  border-color: #f56c6c;
}
.div-uploader-error {
  text-align: center;
  margin: 10px 0 0 0;
  color: #f56c6c;
  font-size: 12px;
}
.avatar-uploader-icon {
  width: 130px;
  height: 70px;
  margin: 80px 50px 50px 50px;
}
.avatar {
  width: 375px;
  height: 192px;
  display: block;
}
.dialogLabel {
  font-size: 18px;
  font-weight: 700;
  text-align: right;
  color: #4a4a4a;
}
.dialogInput {
  width: 90%;
}
.dialogInput2 {
  width: 97%;
}
.btnCancelDialog {
  width: 98px;
  height: 36;
  font-weight: 700;
  font-size: 13px;
}
.btnSaveDialog {
  width: 80px;
  height: 36;
  font-weight: 700;
  font-size: 13px;
  color: #ffffff;
  background: #32c2d5;
  border: 1px solid #32c2d5;
}
.btnSaveDialog:hover {
  background: #32c2d5;
  opacity: 0.8;
  border: 1px solid #32c2d5;
}
.btnDeleteDialog {
  font-size: 15px;
  font-weight: 700;
  height: 50px;
  padding: 9px 25px;
  color: #ffffff;
  background: #f44336;
  border: 1px solid #f44336;
}
.btnDeleteDialog:hover {
  background: #f44336;
  opacity: 0.8;
  border: 1px solid #f44336;
  color: #ffffff;
}
.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}
.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}
.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}
.viewButtonFooter {
  margin-top: 30px;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-end;
  margin-right: 12px;
}
.grid-2-section {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-left {
  .header {
    background-color: #6c30cc;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 40px;
  }
  .body {
    .image-container {
      background-color: #977bbe;
      padding-top: 32px;
    }
    .image-box {
      border-radius: 32px 32px 0 0;
      background-color: #d6d6d6;
    }
    .avatar-uploader,
    .avatar-uploader-error {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      text-align: center;
      height: 192px;
      background: #e3e3e3;
      border-radius: 2px 2px 0 0;
    }
    .avatar-uploader-error {
      border-style: solid;
      border-color: #f56c6c;
    }
    .div-uploader-error {
      text-align: center;
      margin: 10px 0 0 0;
      color: #f56c6c;
      font-size: 12px;
    }
    .avatar-uploader-icon {
      width: 130px;
      height: 70px;
      margin: 0;
    }
    .avatar {
      border-radius: 32px 32px 0 0;
      display: block;
      width: 100%;
    }
    .button-take-reward {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.15);
    }
    .button-redeem {
      background-color: #00cfe8;
      width: 247px;
      height: 36px;
      margin-left: 16px;
      padding: 12px 8px;
      border-radius: 6px;
      color: #fff;
      font-size: 19px;
      box-shadow: 0px 2px #006064;
      > .mock {
        background-color: #00a3b7;
        border-radius: 7px;
        padding: 8px 12px;
        margin-left: 32px;
        > .coin {
          width: 22px;
          height: 22px;
        }
      }
    }
    .button-cencel-redeem {
      width: 65px;
      height: 60px;
      border-radius: 6px;
      color: #747474;
      font-size: 30px;
      font-weight: 900;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
}
.grid-right {
  padding: 32px 64px 32px 32px;
  background-color: #f8f8f8;
  .button-upload {
    background-color: #6c30cc;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    width: 120px;
    height: 44px;
  }
  .button-upload.button-disable {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: default;
  }
  .dialogLabel {
    font-size: 16px;
    font-weight: 700;
    color: #4a4a4a;
  }
}
.btn-add.disable {
  font-size: 15px;
  font-weight: 700;
  height: 50px;
  padding: 9px 32px;
  opacity: 0.5;
  cursor: default;
}
.btn-cancel {
  background-color: #747474;
}
.recipient-user-box {
  padding: 4px 0;
}
.btn-export {
  width: 100px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 700;
}
</style>
<style lang="scss">
#hide-arrow-menu {
  background-color: transparent;
  height: 24px;
  width: 24px;
  .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-submenu__title {
    height: 24px;
    width: 24px;
  }
}
#rewards .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#rewards .el-tabs__header {
  margin: 0px;
}
#rewards > div.el-dialog__wrapper > div > div.el-dialog__header {
  padding: 0px !important;
  padding-bottom: 0px !important;
}
#rewards table {
  border-color: unset;
}
#rewards .el-tabs__content {
  border: 1px solid #e4e7ed;
  border-top: none;
}
#redeemedTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .is-leaf
  > div {
  font-weight: 700;
  font-size: 14px;
}
#redeemedTable > div.is-scrolling-none > table > tbody > tr > td > div {
  font-size: 13px;
}
#redeemedTable
  > div.is-scrolling-none
  > table
  > tbody
  > tr
  > .el-table_3_column_13
  > div {
  font-weight: bold;
  font-size: 13px;
}
#rewards > div:nth-child(3) > div > div.el-dialog__body > div.divTable {
  margin-left: 30px;
  margin-right: 16px;
}
#rewards > div:nth-child(3) > div {
  height: 680px;
  width: 820px;
}
#rewards > div:nth-child(3) > div > div.el-dialog__body {
  padding: 0px 0px 0px 0px;
}
#redeemedTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr:nth-child(1)
  > td.el-table_3_column_13 {
  padding: 0px 0px 0px 0px;
}
#redeemedTable .el-table__body-wrapper {
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 4px;
  }
}
#rewards > div:nth-child(3) {
  overflow: hidden;
}
#rewards .el-menu--horizontal > .el-menu-item {
  color: rgba(0, 0, 0, 0.62);
  font-size: 18px;
  font-weight: 400;
  height: 52px;
}
#rewards .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}
#rewards .el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}
#rewards .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 8px;
}
#rewards .el-dialog__header {
  padding-top: 32px;
  padding-left: 32px;
  padding-bottom: 0px;
}
/* Making the close button the same size across different modal windows */
#rewards i.el-dialog__close.el-icon.el-icon-close {
  font-size: 32px;
  color: #979797;
  margin-top: 6px;
  margin-right: 12px;
}
#enabledInstant span.el-switch__core {
  height: 14px;
  width: 34px !important;
  border: none;
}
#enabledInstant span.el-switch__core::after {
  background: #32c2d5;
  width: 20px;
  height: 20px;
  margin-top: -4px;
  position: absolute;
  left: -1px;
}
#enabledInstant .el-switch.is-checked .el-switch__core::after {
  margin-left: 17px;
}

#rewards #reward_form_modal {
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-menu {
    background-color: transparent;
  }
  .dialogInput {
    width: 100%;
  }
  .el-date-editor .el-range-separator {
    width: 6%;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    font-size: 10px;
    padding-top: 0px;
  }
}
</style>
